<div [formGroup]="form">
  <h4
    id="{{ baseId }}-insurance-service-site-payer-id-mapping-subtitle"
    translate
  >Insurance Service Site Payer ID Mapping</h4>

  <table
    class="table emds-table table-striped table-borderless mt-2"
    formGroupName="ServiceSiteMapping"
  >
    <thead>
      <tr>
        <th></th>
        <th style="width: 50%">Map Item To</th>
        <th style="width: 50%">Substitution Text</th>
        <th></th>
      </tr>
    </thead>
    <tbody
      #dropList
      cdkDropList
      (cdkDropListDropped)="reorder($event)"
    >
      <tr
        *ngFor="let row of serviceSiteMappingFormArray.controls; index as i"
        [formGroupName]="i"
        cdkDrag
        [cdkDragBoundary]="dropList"
        id="{{ baseId }}-row-{{ i }}"
      >
        <div *cdkDragPreview></div>
        <td>
          <mat-icon
            cdkDragHandle
            class="material-icons"
          >drag_handler</mat-icon>
        </td>
        <td>
          <ap-findcontrol
            id="{{ baseId }}-row-{{ i }}-map-item-to"
            controlName="serviceSitePk"
            findControlDisplayName="Find Service Site"
            [selectedPks]="getServiceSiteControl(i).value"
            [baseId]="baseId"
            [form]="form"
            [apFormGroup]="serviceSiteMappingFormArray.at(i)"
            [formGroupSubmitted]="isSubmitted"
            [singleSelect]="true"
            [formGroupSubmitted]="true"
            [findControlId]="FindControlIdService.ListServiceSite"
            (chipsChange)="serviceSiteChanged()"
          >
          </ap-findcontrol>
        </td>
        <td>
          <div class="form-group">
            <input
              id="{{ baseId }}-row-{{ i }}-substitution-text"
              type="text"
              class="form-control"
              [ngClass]="{ error: showErrors(getSubstitutionTextControl(i)) }"
              [maxlength]="500"
              formControlName="substitutionText"
            />
            <div
              *ngIf="showErrors(getSubstitutionTextControl(i))"
              id="{{ baseId }}-warning-text-country"
              class="incorrect-input"
              translate
            >
              {{ getSubstitutionTextControl(i).errors | fcListValidation : 'Substitution Text'
              }}
            </div>
          </div>
        </td>
        <td>
          <div class="emds icons-container">
            <a
              *ngIf="deleteRowButtonVisible(i)"
              role="button"
              title="close"
              (click)="deleteServiceSiteMappingRow(i)"
            >
              <mat-icon class="material-icons">close</mat-icon>
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
